module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal-base', {
    attrs: {
      "open": _vm.opened
    },
    on: {
      "close": function($event) {
        _vm.$emit('close')
      }
    }
  }, [(_vm.challenge) ? _c('challenge-preview', {
    attrs: {
      "challenge": _vm.challenge
    },
    on: {
      "close": function($event) {
        _vm.$emit('close')
      }
    }
  }) : _c('section', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('h2', {
    staticClass: "modal-card-title has-text-centered"
  }, [_vm._v("\n        " + _vm._s(_vm.quizz_title) + "\n      ")])]), _vm._v(" "), _c('article', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "modal-card-body"
  }, [_c('p', {
    staticClass: "app-simple-loader"
  })]), _vm._v(" "), _c('article', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.no_challenge),
      expression: "no_challenge"
    }],
    staticClass: "modal-card-body"
  }, [_vm._m(0)]), _vm._v(" "), (_vm.step == 1) ? _c('article', {
    staticClass: "modal-card-body"
  }, [_c('button', {
    staticClass: "button is-warning",
    on: {
      "click": function($event) {
        _vm.setCat('DESIGN')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('challenges.quizz.cat_design')) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "button is-warning",
    on: {
      "click": function($event) {
        _vm.setCat('DEV')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('challenges.quizz.cat_dev')) + "\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.step == 2) ? _c('article', {
    staticClass: "modal-card-body"
  }, [_c('button', {
    staticClass: "button is-warning",
    on: {
      "click": function($event) {
        _vm.setLevel(1)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('challenges.quizz.lvl_easy')) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "button is-warning",
    on: {
      "click": function($event) {
        _vm.setLevel(2)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('challenges.quizz.lvl_normal')) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "button is-warning",
    on: {
      "click": function($event) {
        _vm.setLevel(3)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('challenges.quizz.lvl_hard')) + "\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.step == 3) ? _c('article', {
    staticClass: "modal-card-body"
  }, [_c('button', {
    staticClass: "button is-warning",
    on: {
      "click": function($event) {
        _vm.getChallenge()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('challenges.quizz.final_1')) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "button is-warning",
    on: {
      "click": function($event) {
        _vm.getChallenge()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('challenges.quizz.final_2')) + "\n      ")])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('challenges.quizz.empty'))
    }
  })
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-394a2841","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChallengeQuizz.vue
// module id = 355
// module chunks = 9